module.exports = __webpack_public_path__ + "static/img/waiting_approve_wallet22.146c704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/waiting_approve_wallet22.png
// module id = dgDV
// module chunks = 31